



















import {Component, Prop} from 'vue-property-decorator';
import {ElementListItem, SurveyElement} from '@/models/Presentation';
import PieChart from '@/assets/pictures/pie_chart.svg';
import BarChart from '@/assets/pictures/bar_chart.svg';
import SurveyForm from '@/assets/pictures/survey_form.svg';
import Base from "@/views/Base";
import {getTokenUrl} from "@/utils/filters";
import AuthenticationService from "@/service/AuthenticationService";


@Component({
  components: { SurveyForm, PieChart, BarChart }
})
export default class ElementThumbnail extends Base {
  @Prop({ required: true }) item!: ElementListItem;

  refreshToken() {
    AuthenticationService.fetchMyAccount();
  }

  get hasThumbnailUrl(): boolean {
    return !!this.item.thumbnailUrl;
  }

  get thumbnailUrl(): string {
    if(this.item.type == 'WEBVIDEO'){
      return this.item.thumbnailUrl || '';
    }
    return getTokenUrl(this.item.thumbnailUrl, this.user.resourceAccessToken);
  }

  get surveyType(): 'SURVEY_FORM' | 'BAR_CHART' | 'PIE_CHART' | undefined {
    if (this.item.type === 'SURVEY_FORM') {
      return 'SURVEY_FORM';
    }
    if (this.item.type === 'SURVEY') {
      const element = this.item.entity as SurveyElement;
      if (element.chartType === 'BAR_CHART_V' || element.chartType === 'BAR_CHART_H') {
        return 'BAR_CHART';
      } else if (element.chartType === 'PIE_CHART' || element.chartType === 'DOUGHNUT_CHART') {
        return 'PIE_CHART';
      }
    }
    return undefined;
  }
}
